{
  "sortLabel": "정렬",
  "sortByOpen": "개시순",
  "sortByOpenHint": "먼저 여는 순서",
  "sortByImpact": "착탄순",
  "sortByImpactHint": "먼저 맞는 순서",
  "kindMain": "main",
  "kindStrike": "strike",
  "kindGarrison": "garrison",
  "kindMarkMain": "M",
  "kindMarkStrike": "S",
  "kindMarkGarrison": "G",
  "timeFormatHint": "mm:ss 또는 mm:ss.s 로 씁니다. 부호 + 나 - 는 앞에 붙입니다(예: -0:00.5).",
  "timeNeeded": "시간을 넣습니다",
  "timeMalformed": "시간 형식이 아닙니다"
}
